export const HOME_PATH = '/';

export const LANDING_PATH = HOME_PATH;
export const CONTACT_PATH = '/contact';
export const PROFILE_PATH = '/profile';
export const SIGN_IN_PATH = '/sign_in';
export const SIGN_UP_PATH = '/sign_up';
export const FAQ_PATH = '/faq';
export const PRIVACY_PATH = '/privacy';
export const BILLING_PATH = '/billing';

export const DASHBOARD_PATH = '/dashboard';
export const DOMAIN_PATH = '/domain';
export const DOMAIN_PAGE_PATH = '/domain/page';
export const ANALITICS_PAGE_PATH = '/analitycs';
export const AFFILIATE_PATH = '/affiliate';
export const THANK_YOU_PATH = '/thanks';
export const EDIT_PASSWORD_PATH = '/passwords/edit/:reset_password_token';



// WEBPACK FOOTER //
// ./src/routes.js